import BlogCard from "../blog/BlogCard";
import SectionTitle from "../common/SectionTitle";
import { Link, useLocation } from "react-router-dom";


export default function HomeBlogSection({ data }) {
        const location = useLocation();
      const isHomePage = location.pathname === "/" || location.pathname === "/home";

  return (
    <div className="blog-area ptb-100">
      <div className="container">
        <SectionTitle data={data} />
        <div className="row">
          {data?.blogs?.slice(0, 3)?.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          )) || (
              <div className="col-12">
                <p className="text-center">No blogs found</p>
              </div>
            )}
          {isHomePage && (
            <div className="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
              <div className="view-all-solutions">
                <Link to="/blog"  className="default-btn">
                  <i className="flaticon-right"></i>
                  View All Blogs <span className="default-btn-hover"></span>
                </Link>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
